$(document).ready(function(){
  // $('ul.itg_menu li').mouseover(function(){
  // //alert('ggg');
  //   $(this).find('.itg_details_headermenu summary').trigger('click');
  // });
  $('.itg_search_icon').click(function(){
    $('.itg_search_popup').slideToggle('active');
  });
  $('.popular-items.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:2
        },
        1000:{
            items:4
        }
    }
});
 
  
  $(".img_producto_container").on("mouseover", function() {
        $(this).find(".img_producto").css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
    })
  $(".img_producto_container").on("mouseover", function() {
    $(this).find(".img_producto").css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
  })
  $(".img_producto_container") .on("mouseout", function() {
    $(this).find(".img_producto").css({ transform: "scale(1)" });
  })
  $(".img_producto_container") .on("mousemove", function(e) {
    $(this).find(".img_producto").css({"transform-origin":((e.pageX - $(this).offset().left) / $(this).width()) * 100 +"% " +((e.pageY - $(this).offset().top) / $(this).height()) * 100 +"%"});
  });

  // product page varinat change title and sku  
  // $('.itg_variant_option').change(function() {
  //   var option_name = $(this).val();
  //    //alert(option_name);
  //   $('.product__title h1 span').text(option_name);
    
  // });

   var altHandle = $('.product-form__input--dropdown select').find(":selected").attr('data-value');
   if(altHandle != undefined){
       $(".itg_slider_desktop .product__media-item").addClass("hide").removeClass("is-active").removeClass("cvariant-image cvariant-item");
       $(".itg_slider_desktop .product__media-item").each(function () {
         $(this).hasClass("alt_" + altHandle) && $(this).removeClass("hide").addClass("cvariant-image cvariant-item");
       });
       $(".itg_slider_desktop .product__media-item.alt_" + altHandle).eq(0).addClass("is-active");
       $(".itg_thumbnail li.thumbnail-list__item").addClass("hide");
       $(".itg_thumbnail li.thumbnail-list__item .global-media-settings").removeAttr('aria-current');
        $(".itg_thumbnail li.thumbnail-list__item").each(function () {
          $(this).hasClass("alt_" + altHandle) && $(this).removeClass("hide");
        });
        $(".itg_thumbnail li.thumbnail-list__item.alt_" + altHandle).eq(0).find(".global-media-settings").attr("aria-current","true").click();
        var variant_title = $('.product-form__input--dropdown select').find(":selected").attr("value").split("(")[0];
        var varinat_sku = $('.product-form__input--dropdown select').find(":selected").attr("var_sku");
         $('.product__title h1 span').text(variant_title);
         $('.product__title p span').text(varinat_sku);
         $('.itg_variant_sku p').text(varinat_sku);
    }

  //inner pages tab script
    $(".itg_tab_list span").click(function(e) {
        var tabName = $(this).attr('data-id');
        $(this).addClass('active_tabs').siblings().removeClass('active_tabs');
        $('.itg_tab_details .itg_tab_content').each(function() {
            var tabName_box = $(this).attr('data-id');
            if (tabName_box == tabName) {
              $(this).addClass('itg_active_content');
            }else{
              $(this).removeClass('itg_active_content');
            }
        })
    });

//bottom popup cookie setup
  $("#cookieconsent-modal").removeClass('hide');
$(".cookieconsent-dismiss").click(function () {      
      $.cookie('cookieconsent', 'accepted', { expires: 365 });
         $("#cookieconsent-modal").slideUp(function(){
				$(this).addClass("hide")
			});
     });    
      var cookieshowhide = $.cookie('cookieconsent');
  if(cookieshowhide == 'accepted') {
    $("#cookieconsent-modal").slideUp(function(){
				$(this).addClass("hide")
			});
	}

//product page selected variant content
$(document).on('change', '.product-form__input .select__select', function(){
 // alert()
  var selected_variant = $(this).find('option:selected').attr('var_sku');
  //alert(selected_variant);
  var html1 = $(document).find('#data_1.itg_tab_data[data="'+selected_variant+'"]').html();
  var html2 = $(document).find('#data_2.itg_tab_data[data="'+selected_variant+'"]').html();
   $(document).find('#tab1.tab-content.tab1').html(html1);
   $(document).find('#tab2.tab-content.tab2').html(html2);
  // console.log(html1);
  // console.log(html2);
});

  
//product page custom tab
// Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first-child').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

// Predictive search
//$('form[action="/search"]').css('position', 'relative').each(function () {
    //var input = $(this).find('input[name="q"]');
    //var offSet = input.position().top + input.innerHeight();
    //$('<ul class="search-results"></ul>').css({'position': 'absolute','left': '0px','top': offSet}).appendTo($(this)).hide();

    //input.attr('autocomplete', 'off').bind('keyup change', function () {
        //var term = $(this).val();
        //var form = $(this).closest('form');
        //var resultsList = form.find('.search-results');

        //// Initial predictive search
        //jQuery.getJSON("/search/suggest.json", {
            //"q": term,
            //"resources": {
                //"type": "product",
                //"limit": 4,
                //"options": {
                    //"unavailable_products": "hide",
                    //"fields": "title,product_type,tag"
                //}
            //}
        //}).done(function (response) {
            //resultsList.empty();
            //var productSuggestions = response.resources.results.products;

            //if (productSuggestions.length > 0) {
                //displayProducts(productSuggestions, resultsList);
            //} else {
                //// If no results, perform an additional search by SKU
                //jQuery.getJSON("/products.json").done(function (allProductsResponse) {
                    //var upperCaseTerm = term.toUpperCase(); // Convert search term to uppercase
                    //var matchedProducts = allProductsResponse.products.filter(function (product) {
                        //return product.variants.some(function (variant) {
                            //return variant.sku.toUpperCase().includes(upperCaseTerm); // Use includes for partial match
                        //});
                    //});
                
                    //if (matchedProducts.length > 0) {
                        //displayProducts(matchedProducts, resultsList);
                    //} else {
                        //resultsList.html('<li><span class="title">No results found.</span></li>');
                    //}
                //});


            //}
        //});
    //});
//});

//$('body').bind('click', function () {
    //$('.search-results').hide();
//});

//function displayProducts(products, resultsList) {
    //products.forEach(function (item, index) {
        //jQuery.getJSON("/products/" + item.handle + ".json").done(function (productResponse) {
            //var product = productResponse.product;
            //var skuText = 'SKU not available';
            //var imageUrl = product.image ? product.image.src : '';
            //var price = product.variants && product.variants.length > 0 ? product.variants[0].price : 'Price not available';

            //if (product.variants && product.variants.length > 0) {
                //skuText = product.variants[0].sku || 'SKU not available';
            //}

            //var productUrl = "/products/" + product.handle; // Construct the URL using the product's handle
            //var link = $('<a class="search-result-link"></a>').attr('href', productUrl);
            //link.append('<div class="itg_thumbnail"><img src="' + imageUrl + '" /></div>');
            //link.append('<div class="itg_prouct_data"><small class="predSearchSKU">' + skuText + '</small><h3 class="title">' + product.title + '</h3> <span class="price">' + '$' + price + '</span></div>');
            //link.wrap('<li></li>');
            //resultsList.append(link.parent());

            //if (index === products.length - 1) {
                //resultsList.fadeIn(100);
            //}
        //});
    //});
//}

// End of Predictive search


  
//menu open on hover
let items = document.querySelector(".header__inline-menu")?.querySelectorAll("details") || [];
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  });

  
});
  // header sticky
//    $(window).scroll(function(){
//     if ($(window).scrollTop() >= 100) {
//       setTimeout(function() {
//         $('.header-wrapper').addClass('fixed');
//         $('.announcement-bar').css("opacity", 0);
//         }, 500);
//      //   $('nav div').addClass('visible-title');
//      // alert()
//     }
//     else {
//       setTimeout(function() {
//         $('.header-wrapper').removeClass('fixed');
//         $('.announcement-bar').css("opacity", 1);
//        }, 500);
//       //  $('nav div').removeClass('visible-title');
//     }
// });
